module.exports = __webpack_public_path__ + "static/impact-analysis-energy-d9125a8dc3734a7f2c2b203a8d39b11e.png";